import React, { useEffect, useRef, useState } from "react";
import { addBaseMap } from "../lib/mapBase";
import { addMapLock } from "../lib/mapLock";
import api from "../lib/api";
import { formatTRY } from "../lib/mw";

export default function MapPage() {
  const ref = useRef(null);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const L = window.L;
    if (!L || !ref.current) return;
    let cancelled = false;
    const map = L.map(ref.current, { center: [39.0, 35.0], zoom: 6, scrollWheelZoom: true, preferCanvas: true });
    addMapLock(map, "musteri");
    addBaseMap(map, "musteri");
    const canvas = L.canvas({ padding: 0.5 });

    api.get("/map/customers", { silent: true }).then((r) => {
      if (cancelled) return;
      setCount(r.data.length);
      r.data.forEach((c) => {
        if (c.lat == null || c.lng == null) return;
        const d = c.data || {};
        const won = d.sonuc === "KAZANILDI";
        const lost = d.sonuc === "KAYBEDİLDİ";
        const color = won ? "#10B981" : lost ? "#EF4444" : "#3B82F6";
        const marker = L.circleMarker([c.lat, c.lng], {
          renderer: canvas, radius: 7, color: "#ffffff", weight: 2, fillColor: color, fillOpacity: 0.95,
        }).addTo(map);
        marker.on("click", () => {
          if (marker.getPopup()) { marker.openPopup(); return; }
          marker.bindPopup(`
          <div style="min-width:200px">
            <div style="font-weight:700;font-size:14px;color:#fff;margin-bottom:4px">${d.firma || "-"}</div>
            <div style="font-size:12px;color:#94A3B8">${d.yetkili || ""}</div>
            <div style="font-size:12px;color:#94A3B8;margin:4px 0">${d.ilce || ""} / ${d.il || ""}</div>
            <div style="font-size:12px;color:#cbd5e1">GSM: ${d.gsm || "-"}</div>
            <hr style="border-color:#334155;margin:6px 0"/>
            <div style="font-size:12px;color:#94A3B8">HEDEF: <b style="color:#e2e8f0">${formatTRY(d.hedef_ciro)}</b></div>
            <div style="font-size:12px;color:#94A3B8">GERÇEKLEŞEN: <b style="color:#34d399">${formatTRY(d.gerceklesen_ciro)}</b></div>
            <div style="font-size:12px;margin-top:4px;color:${color};font-weight:700">${d.sonuc || "DEVAM EDİYOR"}</div>
          </div>`).openPopup();
        });
      });
    });

    return () => { cancelled = true; map.remove(); };
  }, []);

  return (
    <div className="mw-fade-up space-y-4">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="font-head text-3xl font-bold tracking-tight text-white">MÜŞTERİ HARİTASI</h1>
          <p className="text-sm text-slate-400">GERÇEK KONUMLARA GÖRE {count} MÜŞTERİ İŞARETLENDİ</p>
        </div>
        <div className="flex gap-3 text-xs">
          <span className="flex items-center gap-1 text-slate-400"><i className="inline-block h-3 w-3 rounded-full bg-emerald-500" /> KAZANILDI</span>
          <span className="flex items-center gap-1 text-slate-400"><i className="inline-block h-3 w-3 rounded-full bg-blue-500" /> DEVAM</span>
          <span className="flex items-center gap-1 text-slate-400"><i className="inline-block h-3 w-3 rounded-full bg-rose-500" /> KAYBEDİLDİ</span>
        </div>
      </div>
      <div ref={ref} data-testid="customer-map" className="h-[72vh] w-full overflow-hidden rounded-xl border border-slate-800" />
    </div>
  );
}
